import { FC, useEffect, useRef } from "react";

interface SideBarHoursProps {
  currentLang: "en" | "ar";
  clickOnDay: ({ date, startTime }: { date: Date; startTime: string }) => void;
  date: Date;
}

const SideBarHours: FC<SideBarHoursProps> = ({
  currentLang,
  clickOnDay,
  date,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const hours =
    currentLang === "ar"
      ? [
          "7 ص",
          "8 ص",
          "9 ص",
          "10 ص",
          "11 ص",
          "12 م",
          "1 م",
          "2 م",
          "3 م",
          "4 م",
          "5 م",
          "6 م",
          "7 م",
          "8 م",
          "9 م",
          "10 م",
          "11 م",
          "12 ص",
          "1 ص",
          "2 ص",
          "3 ص",
          "4 ص",
          "5 ص",
          "6 ص",
        ]
      : [
          "7 AM",
          "8 AM",
          "9 AM",
          "10 AM",
          "11 AM",
          "12 PM",
          "1 PM",
          "2 PM",
          "3 PM",
          "4 PM",
          "5 PM",
          "6 PM",
          "7 PM",
          "8 PM",
          "9 PM",
          "10 PM",
          "11 PM",
          "12 AM",
          "1 AM",
          "2 AM",
          "3 AM",
          "4 AM",
          "5 AM",
          "6 AM",
        ];
  const handleSetDate = (index: number, half?: boolean) => {
    const hour = index < 17 ? index + 7 : index + 7 - 24;

    const startTime =
      hour >= 10
        ? `${hour}:${half ? "30" : "00"}`
        : `0${hour}:${half ? "30" : "00"}`;
    clickOnDay({
      date: new Date(date),
      startTime,
    });
  };
  const today = new Date();
  const time = today.getHours();
  useEffect(() => {
    // ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [ref.current]);
  return (
    <>
      {hours.map((hour, index) => (
        <>
          <div
            ref={
              (index < 17 ? index + 7 : index + 7 - 24) === time ? ref : null
            }
            className="border-solid relative cursor-pointer z-10 "
            onClick={() => handleSetDate(index)}
            key={index}
          >
            <div
              className={
                currentLang === "ar"
                  ? "absolute -right-11 cursor-pointer z-10 -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                  : "absolute -left-2  cursor-pointer -ml-14 -mt-2.5 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
              }
              onClick={() => handleSetDate(index)}
            >
              {hour}
            </div>
          </div>
          <div
            className=" border-solid  cursor-pointer z-10"
            onClick={() => handleSetDate(index, true)}
            key={index + "h"}
          />
        </>
      ))}
    </>
  );
};

export default SideBarHours;
